import { render, staticRenderFns } from "./Sellerboard.vue?vue&type=template&id=2c634a2a&"
import script from "./Sellerboard.vue?vue&type=script&lang=js&"
export * from "./Sellerboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports